import React from "react";

// The Nexaura wordmark: "NEX" in yellow, "AURA" in blue (solid, no gradient).
export default function BrandName({ className = "" }) {
  return (
    <span className={`brandname ${className}`}>
      <span className="b-nex">NEX</span>
      <span className="b-aura">AURA</span>
    </span>
  );
}
